import * as yup from 'yup';

export const passwordRequestSchema = yup.object().shape({
  username: yup.string().required(),
});

export const defaultValuesPasswordRequestForm = {
  username: '',
};
